import React from 'react';
import List from '@material-ui/core/List';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Speaker from './Odj/Speaker.js';

export default class Speakers extends React.Component {

  state = {
    programs: [],
    programSelected: 0,
    speakers: [],
    isBroadcasting: false
  }

  async componentDidMount() {
    this.programs = await window.sdk.getSpeakerPrograms(window.programId);
    this.setState({
      programs: this.programs,
      isBroadcasting: window.sdk.live.streamInfo.program.live_state,
      speakers: this.programs[0].speakers
    })
    
    window.sdk.on('monitorStream', () => {
      this.setState({
        isBroadcasting: window.sdk.live.isInPublicLive()
      })
    });
    
    
    let lastClicked = window.sdk.live.getLastClickedCuepoint('speaker');
    console.log('lastClicked', lastClicked)
    if(lastClicked) {
      let interval = setInterval(() => {
        if(this.refs['speaker-' + lastClicked]) {
            this.refs['speaker-' + lastClicked].setCurrent(true);
            clearInterval(interval)
        }
      }, 300)
    }
        
    window.sdk.on('noLiveSpeakerAnymore', (id) => {
      if(this.refs['speaker-' + id])
        this.refs['speaker-' + id].setCurrent(false);
    });
    
    
    
  }
  
  handleChange = (e) => {
    this.setState({
      programSelected: e.target.value
    })
    
    this.setState({
      speakers: this.programs[e.target.value].speakers
    })
  }
  
  cleanSpeaker = () => {
	window.sdk.emit('noLiveSpeakerAnymore', window.sdk.live.getLastClickedCuepoint('speaker'));
    window.sdk.live.setLiveCurrent('speaker', -1);
  }

  render() {
    if(this.state.programs.length < 1)
      return null;
    
    
    
    return (
      <div className={ 'odj ' }  id="speaker_list">
        
		<button onClick={ this.cleanSpeaker }>Vider le panneau speaker</button>
        
        
        <Select style={{ width: '100%' }} autoWidth={ true } value={this.state.programSelected} onChange={this.handleChange}>
          {this.state.programs.map((program, index) => {
            return (
              <MenuItem  key={ index } value={ index }>{ program.title }</MenuItem>
            );
          })}
        </Select>
        
        
        { this.state.speakers.length > 0 &&
          <List dense={ true }>
            {this.state.speakers.map((speaker, index) => {
              return (
                <Speaker ref={'speaker-' + speaker.id} key={ index } speaker={ speaker } isBroadcasting={ this.state.isBroadcasting }>
                
                </Speaker>
              );
            })}
          </List> 
        }
        
        
      </div>
    )
  }
  
}



// WEBPACK FOOTER //
// ./src/Manager/Speakers.js